/* eslint-disable react-hooks/exhaustive-deps */
import {
  faEllipsisV,
  faMagnifyingGlass,
  faCopy
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useState } from "react";
import { Button, Form, Image, InputGroup } from "react-bootstrap";
import { Divider, Dropdown, Loader, Tooltip, Whisper, toaster } from "rsuite";
import Alert from "../notification/Alert";
import { supportedFiles } from "../../libs/dataSelects";
import peticionBack from "../../libs/peticiones/peticionBack";
import PageIcon from "@rsuite/icons/Page";
import { eliminarTildes } from "../../libs/formats";
import { Status } from "../../enums/Status";
import { statusAudio } from "../../pages/visualizar-archivos/Main";

export default function DetailFile({
  archivo,
  textSearch,
  route,
  hookStateAudio
}: {
  archivo?: any;
  textSearch?: string;
  route?: string;
  hookStateAudio: [statusAudio,Function];
}) {

  const [loading, setLoading] = useState<boolean>(false);
  const [search, setSearch] = useState<string>(""); // filtro de busqueda , value
  const [fullContent, setFullContent] = useState<string>(""); // Texto archivo
  const [pages, setPages] = useState<{ page: number; text: string }[]>([]); // paginas archivo
  const [splitedContent, setsplitedContent] = useState<any[]>([]); // Texto archivo separado por filtro
  const [tokens, setTokens] = useState<Array<string>>([]); // Palabras claves extraidas por el back
  const [stateAudio, setStateAudio] = hookStateAudio;

  useEffect(() => {
    configDocument();
    // getStatusTts(false);
  }, []);

  async function sendTextAudio() {
    if (archivo._id) {
      const res = await peticionBack(
        null,

        `/files/send_tts/${archivo._id}`,
        "ṔOST",
        false,
        null,

      );

      let status = null;
      if (res) {
        if (Array.isArray(res)) {
          status = res[0].status;
          setStateAudio(res[0]);
        } else {
          status = res.status;
          setStateAudio(res);
        }
      }

      if (status) {
        if (status === Status.STARTED || status === Status.PENDING) {
          showProcessingFile();
        } else {
          showErrorFile();
        }
      } else {
        showErrorFile();
      }

      if (stateAudio?.status === Status.STARTED) {
        toaster.push(
          Alert({
            type: "success",
            message: "Se ha enviado a procesar",
          }),
          {
            placement: "topEnd",
          }
        );
      }
    }
  }
  function showErrorFile() {
    toaster.push(
      Alert({
        type: "error",
        message: "Hubo un error al intentar procesar el archivo",
      }),
      {
        placement: "topEnd",
      }
    );
  }

  function showProcessingFile() {
    toaster.push(
      Alert({
        type: "warning",
        message: "El archivo esta siendo procesado",
      }),
      {
        placement: "topEnd",
      }
    );
  }

  function configDocument() {
    if (archivo) {
      setPages(archivo.pages);
      let fulltext = "";
      archivo.pages.forEach((p: any) => {
        if (typeof p.text === "string") {
          fulltext += `Página: ${p.page}\n${p.text}\n\n`;
        } else {
          fulltext += `Página: ${p.page}\n${(p.text as string[]).join(
            "\n"
          )}\n\n`;
        }
      });
      setFullContent(fulltext);
      if (textSearch) {
        setSearch(textSearch);
        handleSearch(false, textSearch);
      }
    } else setPages([]);
  }

  useEffect(() => {
    if (search === "") {
      setsplitedContent([]);
    }
  }, [search]);

  function findType(t: string) {
    if (archivo && supportedFiles[t]) {
      return supportedFiles[t].includes(archivo.type);
    }
    return false;
  }

  async function handleSearch(e: any, tSearch?: string) {
    if (e) e.preventDefault();
    if (!search && !tSearch) return;
    setLoading(true);
    const res = await peticionBack(
      {},
      route
        ? `/files/search/${encodeURIComponent(route)}?search=${
            tSearch || search
          }`
        : `/files/search/${encodeURIComponent(archivo.id)}?search=${
            tSearch || search
          }`,
      "GET",
      false,
      toaster
    );
    if (res) {
      const paginas: any[] = [];
      res.data.forEach((pc: PageIndexes) => {
        const paraf: any[] = [];
        let st = 0;
        pc.indexes.forEach((n: { start: number; end: number }, ix: number) => {
          paraf.push(pc.text.substring(st, n.start));
          paraf.push(pc.text.substring(n.start, n.end));
          st = n.end;
        });
        paraf.push(pc.text.substring(st, pc.text.length));
        paginas.push({ page: pc.page, sep: [...paraf] });
      });

      setsplitedContent(paginas);
      setTokens(res.tokens);
      // setSearched(tSearch ? tSearch : "");
    }
    setLoading(false);
  }

  /* =================== Boton copiar ==================== */
  async function copyClipboard() {
    try {
      if (fullContent) {
        if (navigator.clipboard)
          await navigator.clipboard.writeText(fullContent);
        else commandCopyClipboard();
        toaster.push(Alert({ type: "info", message: "Texto copiado" }), {
          placement: "topCenter",
        });
      }
    } catch (error) {
      toaster.push(
        Alert({
          type: "warning",
          message: "No se puede copiar al portapapeles",
        }),
        { placement: "topCenter" }
      );
    }
  }

  function commandCopyClipboard() {
    const textArea = document.createElement("textarea");
    textArea.value = fullContent || "";
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
    document.execCommand("copy");
    document.body.removeChild(textArea);
  }

  function onChange({ target }: any) {
    setSearch(target.value);
  }
  function getTypeButton() {

  if (stateAudio?.status === Status.STARTED || stateAudio?.status === Status.RETRY) {
  const text =
    stateAudio.status === Status.STARTED
      ? "Iniciando reproducción..."
      : "Hubo un fallo, intentando nuevamente...";
  return (
    <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 8 }}>
      <Loader />
      <span>{text}</span>
    </div>
  );
} else {
      return (
        <div className="d-flex flex-column justify-content-center">
      {   (archivo.status === Status.SUCCESS && stateAudio?.status !== Status.PENDING) && <Button
            variant="outline-primary"
            className="ml-5"
            type="button"
            onClick={() => {
              // stateAudio?.status === Status.SUCCESS
              //   ? getStatusTts(true):
                 sendTextAudio();
            }}
          >
            {stateAudio?.status === Status.FAILURE
              ? "Reintentar"
              : "Transformar a audio"}
          </Button>}
          {(stateAudio?.status === Status.PENDING) && (
            <span className="text-center">
              El archivo esta siendo procesado (Conversión de texto a voz), intentelo de nuevo en unos
              minutos
          </span>
          )}
        </div>
      );
    }
  }

  if (!archivo)
    return (
      <div>
        <div className="my-1">
          <div className="stage">
            <div className={`box shake-6 text-center`}>
              <Image
                src={`/images/file-search.svg`}
                alt="lock-file"
                height={120}
                width={120}
              />
            </div>
          </div>
          <h5 className="text-center">No se identificó el archivo</h5>
        </div>
      </div>
    );

  return (
    <div style={{ minWidth: "100%" }}>
      {findType("PDF") ? (
        <iframe
          src={archivo.src}
          width="100%"
          style={{ height: "70vh", overflow: "auto" }}
          title="show-pdf"
        >
          <p>Dispositivo no compatible</p>
        </iframe>
      ) : (
        findType("IMAGE") && (
          <div className="text-center">
            <Image src={archivo.src} fluid alt="file-img" />
          </div>
        )
      )}

      {stateAudio &&
      stateAudio.status === Status.SUCCESS &&
      stateAudio.url &&
      stateAudio.url !== "" &&
      stateAudio.url ? (
        <div className="d-flex justify-content-center mt-3">
          <audio preload="auto" controls>
            <source src={stateAudio.url} type="audio/mp3" />
            <source src={stateAudio.url} type="audio/ogg" />
            <source src={stateAudio.url} type="audio/wav" />
          </audio>
        </div>
      ) : (
        <div className="d-flex justify-content-center gap-2 mt-3 ">
          {getTypeButton()}
        </div>
      )}

      {archivo.status === Status.NO_PROCESS ? (
        <div className="text-center">
          <h4>El archivo no sera procesado</h4>
        </div>
      ) : (
        <div className="position-relative">
          {archivo.status === Status.SUCCESS ? (
            <div className="m-3 position-relative">
              <form role="search" onSubmit={handleSearch}>
                <InputGroup className="mb-3 d-flex">
                  <Form.Control
                    type="search"
                    id="search"
                    name="search"
                    value={search}
                    placeholder="Buscador"
                    onChange={onChange}
                    aria-label="Input with two button addons"
                  />
                  <Button variant="outline-primary" type="submit">
                    <FontAwesomeIcon
                      icon={faMagnifyingGlass}
                      style={{ minWidth: "15px", maxWidth: "15px" }}
                    />
                  </Button>
                  <Whisper
                    placement="top"
                    controlId="tt-cpy"
                    trigger="hover"
                    speaker={<Tooltip>Copiar contenido</Tooltip>}
                  >
                    <Button
                      variant="outline-secondary rounded-end"
                      type="button"
                      onClick={() => copyClipboard()}
                    >
                      <FontAwesomeIcon
                        icon={faCopy}
                        style={{ minWidth: "15px", maxWidth: "15px" }}
                      />
                    </Button>
                  </Whisper>
                </InputGroup>
              </form>

              <div className="mt-3">
                <h4 className="text-center">Contenido</h4>
                <div
                  className="border p-3"
                  style={{ maxHeight: "60vh", overflowY: "auto" }}
                >
                  {splitedContent.length > 0 ? (
                    <div>
                      {splitedContent.map(
                        (sp: { page: number; sep: string[] }) => (
                          <PageComp key={"ps" + sp.page} page={sp.page}>
                            <p className="text-justify text-breaks">
                              {sp.sep.map((t: string, ix: number) => (
                                <span
                                  key={"pst" + sp.page + ix}
                                  className={
                                    tokens.includes(
                                      eliminarTildes(t).toUpperCase()
                                    )
                                      ? "bg-primary text-white"
                                      : ""
                                  }
                                >
                                  {t}
                                </span>
                              ))}
                            </p>
                          </PageComp>
                        )
                      )}
                    </div>
                  ) : (
                    <div>
                      {pages.length > 0 &&
                        pages.map((p: any) => (
                          <PageComp key={"p" + p.page} page={p.page}>
                            <p className="text-justify text-breaks">
                              {typeof p.text === "string"
                                ? p.text
                                : (p.text as string[]).join("\n")}
                            </p>
                          </PageComp>
                        ))}
                    </div>
                  )}
                </div>
              </div>
            </div>
          ) : (
            <div className="text-center mt-5 pt-3">
              {archivo.status === Status.NO_PROCESS ? (
                <h6>Documento no procesado</h6>
              ) : (
                <h6>El documento aún está siendo procesado</h6>
              )}
            </div>
          )}
          {loading && <Loader center backdrop style={{ zIndex: "5" }} />}
        </div>
      )}
    </div>
  );
}

function PageComp({ children, page }: { children: any; page: number }) {
  return (
    <div>
      <div className="d-flex flex-row justify-content-between">
        <h5 className="mb-2">Página: {page}</h5>
        <Dropdown renderToggle={renderConfig} placement="leftStart">
          <Dropdown.Item icon={<PageIcon />}>Generar resumen</Dropdown.Item>
        </Dropdown>
      </div>
      {children}
      <Divider />
    </div>
  );
}

const renderConfig = (props: any, ref: any) => {
  return (
    <FontAwesomeIcon
      {...props}
      ref={ref}
      icon={faEllipsisV}
      className="text-body-secondary"
      style={{ fontSize: "18px" }}
    />
  );
};

interface PageIndexes {
  page: number;
  indexes: { start: number; end: number }[];
  text: string;
}
